module.exports = __webpack_public_path__ + "static/img/goodImages1.a394b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goodImages1.png
// module id = 2DN5
// module chunks = 3